<template>
    <div id='container'>
        <div id="body">
            <template v-if="page === 'group1' || page === ''">
                <BaseShare />
            </template>
            <template v-if="page === 'group2'">
                <AutoFeed />
            </template>
            <template v-if="page === 'group3'">
                <AutoSide  />
            </template>
            <template v-if="page === 'group4'">
                <ManualFeed />
            </template>
        </div>
    </div>
</template>

<script>
import BaseShare from './pages/BaseShare.vue'
import AutoFeed from './pages/AutoFeed.vue';
import AutoSide from './pages/AutoSide.vue';
import ManualFeed from './pages/ManualFeed.vue'
import { getCookie } from '@/utils/cookie';
import { get } from './utils/utils';
import { getUrlParam } from '@/utils/url';
import kylogger from '@ky/sdk/dist/log/kylogger';

export default {
    name: 'share-v2',
    components: {
        BaseShare,
        AutoFeed,
        AutoSide,
        ManualFeed,
    },
    data() {
        return {
            page: 'group1',
        };
    },
    methods: {
        async getAbValue(params){
            const {data} = await get('/rest/n/kmovie/app/resource/getH5Abtest', params);
            console.log('ab data',data)
            if (data && data.result === 1) {
                this.page = data.value;
                return data;
            }
            return Promise.reject(data);
        },
        randomValue(){
            const index = Math.floor(Math.random()*Math.floor(4));
            console.log('ab index--',index)
            let arr =['group1','group2','group3','group4']
            this.page = arr[index]
        }
        
    },
    mounted() {
        this.getAbValue({abParam:'Kuaiying_share_h5',webdid: getCookie('did') || getCookie('_did')});
        document.title = this.$t('title');
        kylogger.collect('PV', 'MV_SHARE_H5', {
            share_url: location.href,
            page_name:'kwaiying-template-share-base',
            share_channel:getUrlParam('channel') ||''
        });
    },
};
</script>

<style lang="less" scoped>
#container{
    background-color: #141414;
    height: 100%;
}
#body {
    width: 100%;
    height: 100%;
    background-color: #141414;
    font-family: PingFangSC, PingFangSC-Regular;
}
</style>
